// Init axios ajax
var cordiaAPI = axios.create({
  baseURL: localize.apiendpoint,
});

console.log("cordiaAPI", cordiaAPI);

const RECAPTCHA_SITE_KEY = localize.captcha_site_key;
const RECAPTCHA_PROTECTED_PATHS = [
  "/user/gdpr",
  "/newsletter/subscribe",
  "/sf/offers",
  "/sf/investor",
];

// General button lock var for prevent double ajax calls
var buttonLock = false;

/* Check if is logged in */
var userToken = Cookies.get("token");

(function ($) {
  "use strict";

  $(function () {
    /* Init Object fit images polyfill */
    objectFitImages();
    objectFitVideos();

    $.langCookie = Cookies.get("_icl_current_language");
    if ($.langCookie == undefined) {
      $.langCookie = Cookies.get("wp-wpml_current_language");
    }

    /* Setting up facebook api */
    $.ajaxSetup({ cache: true });

    $(".js-back-to-search").on("click", function (e) {
      e.preventDefault();
      const filterHistory = Cookies.get("filter_history");
      location.href = filterHistory || $(this).attr("href");
    });

    /* Redirect to search page with parameters from main page */
    $(".js-flatsearch-button").on("click", function (e) {
      e.preventDefault();
      if (!$(this).is(".js-detailed-filters-button")) {
        const params = $.urlParams ? `?${$.urlParams}` : "";
        window.location.href = `${localize.flatSearchUrl}${params}`;
      }
    });

    $(".js-discounted-apartments").on("click", function (e) {
      e.preventDefault();
      if ($(this).hasClass("js-discounted-apartments-offers")) {
        var searchLink = $(this)
          .parents(".m-residential__card")
          .parent()
          .find(".js-freeflats")
          .attr("href");
        window.location.href = `${searchLink}&kl=1`;
      } else {
        const params = $.urlParams ? `?${$.urlParams}&kl=1` : "";
        window.location.href = `${localize.flatSearchUrl}${params}`;
      }
    });

    $(".js-discounted-apartments-custom-link").on("click", function (e) {
      e.preventDefault();
      window.location.href = $(this).data("link");
    });

    /* Resseting filters */
    $(".js-reset-search").on("click", function (e) {
      e.preventDefault();
      $.lakaskereso.deleteFilters();
    });

    /* Validate phonenumber */
    $(document).on("input propertychange", ".js-telephone", function () {
      if ($(this).val().indexOf("+") === -1) {
        $(this).val("+" + $(this).val());
      }
    });

    $(document).on("keypress keyup blur", ".js-telephone", function (event) {
      $(this).val(
        $(this)
          .val()
          .replace(/[^0-9\+].+/, "")
      );
      if (event.which < 48 || event.which > 57) {
        event.preventDefault();
      }
    });

    $(".js-show-more").on("click", function (e) {
      e.preventDefault();
      const $this = $(this);
      $this.toggleClass("active");
      const $id = $this.attr("href");
      const $el = $($id);
      $el.slideToggle();
      $el[0].scrollIntoView({ behavior: "smooth" });
      $(".jarallax").jarallax("destroy").jarallax({ speed: 0.2 });
    });

    $(".js-custom-select-new-residentials").SumoSelect({
      placeholder: localize.translations.optionSelectText,
      csvDispCount: 2,
      captionFormat: `{0} ${localize.translations.optionCaption}`,
      captionFormatAllSelected: `${localize.translations.allSelected}`,
      search: false,
      searchText: localize.translations.searchText,
      noMatch: `${localize.translations.searchTextNoMatch} "{0}"`,
    });

    $(".js-custom-select-news").SumoSelect({
      placeholder: localize.translations.optionSelectText,
      csvDispCount: 2,
      captionFormat: `{0} ${localize.translations.optionCaption}`,
      captionFormatAllSelected: `${localize.translations.allSelected}`,
      search: false,
      searchText: localize.translations.searchText,
      noMatch: `${localize.translations.searchTextNoMatch} "{0}"`,
    });

    $(".js-custom-select-news").on("change", function (e) {
      e.preventDefault();
      window.location = $(this).val();
    });

    $(".js-custom-select-residential-selector").SumoSelect({
      placeholder: localize.translations.optionSelectText,
      csvDispCount: 2,
      captionFormat: `{0} ${localize.translations.optionCaption}`,
      captionFormatAllSelected: `${localize.translations.allSelected}`,
      search: false,
      searchText: localize.translations.searchText,
      noMatch: `${localize.translations.searchTextNoMatch} "{0}"`,
    });

    $(".js-custom-select-residential-selector").on("change", function (e) {
      e.preventDefault();
      window.location = $(this).val();
    });

    const newsMenu = document.getElementById("js-news-menu");
    if (newsMenu) {
      const activeStep = newsMenu.querySelector(".active");
      activeStep.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "center",
      });
    }

    $(document).on("click", ".js-tour-link", function (e) {
      e.preventDefault();
      const href = $(this).attr("href");

      if (!href) {
        return;
      }

      if (!$("#js-3dtour-modal").length) {
        return;
      }

      $("#js-3dtour-modal").iziModal({
        iframe: true,
        headerColor: "#000000",
        iframeHeight: "100vh",
        width: "100vw",
        iframeURL: href,
        appendTo: ".modals-wrapper",
        zindex: 998,
        closeButton: true,
        onClosed: function () {
          $("#js-3dtour-modal").iziModal("destroy");
        },
      });

      $("#js-3dtour-modal").iziModal("open");
    });

    if (!$(".template--marina-city").length) {
      $("video").each(function () {
        $(this).prop({
          controls: true,
          controlslist: "nodownload",
        });
        const videoObserver = new window.IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) {
              if (this.paused) {
                $(this).prop("muted", true);
                this.play();
              }
            } else {
              this.pause();
            }
          },
          {
            threshold: 0.5,
          }
        );
        videoObserver.observe(this);
      });
    }
  });
})(jQuery);
